// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

class PhotoDescriptionContainer extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    image: PropTypes.any,
    description: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    image: null,
    description: 'no text'
  };

  render() {
    const { classes, image, description } = this.props;

    return (
      <div className={classes.mainContainer}>
        <img className={classes.square} src={image} alt={'src'} />
        <span className={classes.text}>{description}</span>
      </div>
    );
  }
}

export default withStyles(styles)(PhotoDescriptionContainer);
